import { Chakra } from "@airhelp/react-ui-components";
import BreadcrumbsSchema from "modules/storyblok/components/BreadcrumbsSchema";
import { stickyBottomBarFirstTriggerStyles } from "components/StickyBottomBar";
import StickyBottomBarTrigger from "components/StickyBottomBar/StickyBottomBarTrigger";
import { DataContextProvider } from "contexts/DataContext";
import { ModalContextProvider } from "contexts/ModalContext";
import { StickyBottomBarContextProvider } from "contexts/StickyBottomBarContext";
import CustomHead from "modules/common/components/CustomHead";
import FooterSimple from "modules/common/components/FooterSimple";
import PressLogos from "modules/common/components/PressLogos";
import StickyBottomBarAdapter from "../../adapters/StickyBottomBar";
import { DynamicComponent } from "../../DynamicComponent";
import type { BaseTemplate } from "../../types";
import { actionButtonsConfig } from "./ActionButtons";
import type { TemplateContent } from "./AirhelpPlus.d";
import HeaderNav from "./HeaderNav";
import { menuLinkConfig } from "./MenuItems";

const { Box } = Chakra;

const AirHelpPlus = ({
  story,
  cmsLanguagesData,
  translations,
  serverSideStoryblokPages,
  whiteListDomains,
  storyblokComponentData: { trustpilotInfo, reviews },
}: BaseTemplate<TemplateContent>) => {
  const {
    content: {
      metaTitle,
      metaDescription,
      content,
      breadcrumbsParentPage,
      breadcrumbsPositionName,
      ogTitle,
      ogImageUrl,
      ogDescription,
      stickyBottomBarHeading,
      hideStickyBottomBar,
      stickyBottomBarVariant,
    },
  } = story;

  const showLanguageSwitcher = story?.content?.languageSwitcher;

  return (
    <DataContextProvider
      data={{
        reviews,
        cmsLanguagesData,
        serverSideStoryblokPages,
        trustpilotInfo,
        translations,
        whiteListDomains,
      }}
    >
      <CustomHead
        title={metaTitle}
        description={metaDescription}
        ogTitle={ogTitle}
        ogDescription={ogDescription}
        ogImageUrl={ogImageUrl}
      />
      <BreadcrumbsSchema
        breadcrumbsPositionName={breadcrumbsPositionName}
        breadcrumbsParentPage={breadcrumbsParentPage}
      />
      <ModalContextProvider>
        <HeaderNav
          menuItems={menuLinkConfig}
          buttons={actionButtonsConfig}
          showLanguageSwitcher={showLanguageSwitcher}
          pt={4}
        />
        <Box pt={12} as="main">
          <StickyBottomBarTrigger type="first" styles={stickyBottomBarFirstTriggerStyles} />
          {content ? content.map((blok) => <DynamicComponent blok={blok} key={blok._uid} />) : null}
        </Box>
        <PressLogos />
        <FooterSimple />
      </ModalContextProvider>
      <StickyBottomBarAdapter
        showStickyBottomBar={!hideStickyBottomBar}
        stickyBottomBarVariant={stickyBottomBarVariant}
        stickyBottomBarHeading={stickyBottomBarHeading}
      />
    </DataContextProvider>
  );
};

const AirHelpPlusAdapter = (props) => (
  <StickyBottomBarContextProvider threshold={0.4}>
    <AirHelpPlus {...props} />
  </StickyBottomBarContextProvider>
);

export default AirHelpPlusAdapter;
